import { useMutation, useQueryClient } from "@tanstack/react-query";

import { mutateData } from "@/core/api/api-methods";
import {
  apiErrorHandler,
  getBackendErrorMessage,
} from "@/core/api/api-error-handler";
import { invalidateAfterMutation } from "@/core/api/invalidate-after-mutation";
import { QUERY_KEYS } from "@/core/api/query-keys";
import { logger } from "@/core/utils/func/logger";
import { walletEndpoints } from "@/features/wallet/api/endpoints";

/**
 * Supprime un bénéficiaire (`DELETE /Beneficiaries/{id}`) puis invalide la
 * liste du portefeuille concerné (`walletId` requis pour l'invalidation).
 */
export const useDeleteBeneficiary = (walletId: string) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ["wallet", "beneficiaries", "delete", walletId],
    mutationFn: (beneficiaryId: string) =>
      mutateData({
        url: walletEndpoints.beneficiaries.remove(beneficiaryId),
        method: "DELETE",
      }),
    onSuccess: () => {
      return invalidateAfterMutation(queryClient, [
        QUERY_KEYS.WALLET_BENEFICIARIES(walletId),
      ]);
    },
    onError: (error) => {
      const message = getBackendErrorMessage(error) ?? apiErrorHandler(error);
      logger.error(
        `useDeleteBeneficiary failed: ${message}`,
        error instanceof Error ? error : undefined,
        { prefix: "wallet" }
      );
    },
  });
};
